var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin",staticStyle:{"min-height":"100vh"}},[_c('div',{attrs:{"id":"layoutSidenav"}},[_c('AsideMenu'),_c('div',{attrs:{"id":"layoutSidenav_content"}},[_c('main',[_c('router-view')],1)])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }